import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
const rowsPerPageOptions = [10, 25, 50, 100];
export default function RowsPerPageMobileSelect({
  getRows,
  handleChangeRowsPerPage,
}) {
  const { t } = useTranslation();
  return (
    <FormControl variant="outlined" sx={{ width: "100%", m: 2 }}>
      <InputLabel id="rows-per-page-label">{t("RowsPerPage")}</InputLabel>
      <Select
        labelId="rows-per-page-label"
        value={getRows()}
        onChange={handleChangeRowsPerPage}
        label={t("RowsPerPage")}
      >
        {rowsPerPageOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
